import React from "react";
import { css } from "@emotion/css";
import { visionMissionNew } from "../../assets/images";

const VisionMission = () => {
    const visionMissionStyles = {
        section: css`
            padding: 32px 0;
            background-color: white;

            @media (min-width: 640px) {
                padding: 48px 0;
            }

            @media (min-width: 1024px) {
                padding: 64px 0;
            }
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;

            @media (min-width: 640px) {
                padding: 0 1.5rem;
            }

            @media (min-width: 1024px) {
                padding: 0 2rem;
            }
        `,
        grid: css`
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 32px;
            align-items: center;

            @media (min-width: 640px) {
                gap: 40px;
            }

            @media (min-width: 1024px) {
                grid-template-columns: repeat(3, 1fr);
                gap: 48px;
            }
        `,
        leftPanel: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
            height: 100%;
            align-items: center;
            justify-content: center;
            border: 1px solid #f0f0f0;
            padding: 20px;
            border-radius: 4px;

            @media (min-width: 640px) {
                gap: 20px;
            }

            @media (min-width: 1024px) {
                gap: 24px;
            }
        `,
        visionTitle: css`
            font-size: 1.25rem;
            font-weight: bold;
            color: #dc2626;
            margin-bottom: 12px;

            @media (min-width: 640px) {
                font-size: 1.375rem;
                margin-bottom: 14px;
            }

            @media (min-width: 1024px) {
                font-size: 1.5rem;
                margin-bottom: 16px;
            }
        `,
        visionText: css`
            color: #374151;
            line-height: 1.6;
            font-size: 0.875rem;

            @media (min-width: 640px) {
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                font-size: 1rem;
            }
        `,
        centerPanel: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
        imageContainer: css`
            position: relative;
            border-radius: 16px;
            overflow: hidden;
            ${"" /* box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); */}
        `,
        visionImage: css`
            width: 100%;
            max-width: 100%;
            height: 16rem;
            object-fit: cover;

            @media (min-width: 640px) {
                max-width: 20rem;
                height: 18rem;
            }

            @media (min-width: 1024px) {
                max-width: 24rem;
                height: 20rem;
            }
        `,
        rightPanel: css`
            display: flex;
            flex-direction: column;
            gap: 16px;
            height: 100%;
            align-items: center;
            justify-content: center;
            border: 1px solid #f0f0f0;
            padding: 20px;
            border-radius: 4px;

            @media (min-width: 640px) {
                gap: 20px;
            }

            @media (min-width: 1024px) {
                gap: 24px;
            }
        `,
        missionTitle: css`
            font-size: 1.25rem;
            font-weight: bold;
            color: #dc2626;
            margin-bottom: 12px;

            @media (min-width: 640px) {
                font-size: 1.375rem;
                margin-bottom: 14px;
            }

            @media (min-width: 1024px) {
                font-size: 1.5rem;
                margin-bottom: 16px;
                margin-bottom: 16px;
            }
        `,
        missionText: css`
            color: #374151;
            line-height: 1.6;
            font-size: 0.875rem;

            @media (min-width: 640px) {
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                font-size: 1rem;
            }
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }

            @media (max-width: 768px) {
                text-align: justify;
            }
        `,
    };

    return (
        <section
            className={visionMissionStyles.section}
            id="vision-mission"
            aria-labelledby="vision-mission-title"
        >
            <div className={visionMissionStyles.container}>
                <div className={visionMissionStyles.grid}>
                    {/* Left Panel - Our Vision */}
                    <div className={visionMissionStyles.leftPanel}>
                        <h3 className={visionMissionStyles.visionTitle}>
                            Our Vision
                        </h3>
                        <p className={visionMissionStyles.visionText}>
                            To break the notion of limited identity of an
                            individual and lead oneself to explore and
                            experience infinity through the Celebration of
                            Oneness.
                        </p>
                    </div>

                    {/* Center Panel - Image */}
                    <img
                        src={visionMissionNew}
                        alt="Five hands joined together in unity and collaboration"
                        className={visionMissionStyles.visionImage}
                    />

                    {/* Right Panel - Our Mission */}
                    <div className={visionMissionStyles.rightPanel}>
                        <h3 className={visionMissionStyles.missionTitle}>
                            Our Mission
                        </h3>
                        <p className={visionMissionStyles.missionText}>
                            To mold the uniqueness within every individual to
                            reveal each individual's highest possible
                            creativity, innovation and intelligence.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisionMission;
